import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { system } from 'styled-system';
import { Section } from '../components/Section';
import { Container } from '../components/Container';
import { Box } from '../components/Box';
import { Column, Grid } from '../components/Grid';
import { Text } from '../components/Text';
import { Stack } from '../components/Stack';
import {
  AppleMusic,
  Facebook,
  Instagram,
  Spotify,
  Tiktok,
  YouTube
} from '../components/Icons';
import { SocialIcon } from '../components/IconLink';
import { NewsletterSignupInternalLink } from '../components/NewsletterSignupInternalLink';

export function Home() {
  return (
    <Section id="home" background="var(--red)" py={0}>
      <Container fluid>
        <Box
          position="relative"
          display="flex"
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          pt="84px"
        >
          <Grid
            gridGap="24px"
            gridTemplateColumns="repeat(12, 1fr)"
            style={{ maxWidth: '750px' }}
          >
            <Column
              style={{ display: 'flex', justifyContent: 'center' }}
              gridColumn="span 12 / span 12"
            >
              <StaticImage
                src="../images/covers/dig.jpg"
                alt="Dig album cover"
                placeholder="blurred"
                objectFit="contain"
                loading="eager"
                height={450}
                width={450}
                backgroundColor="#e09f43"
                style={{
                  boxShadow: 'var(--black-shadow)',
                  borderRadius: '5px'
                }}
              />
            </Column>
            <AlbumNameColumn gridColumn="span 12 / span 12">
              <Box display="flex" justifyContent="center" flex={1}>
                <h1
                  style={{
                    // fontFamily: 'var(--display-font-stack)',
                    fontSize: '1rem',
                    fontWeight: 700,
                    color: 'var(--marigold)',
                    textShadow: '0px 0px 9px #b92f2f5e',
                    margin: 0,
                    letterSpacing: 'var(--display-spacing-sm)'
                  }}
                >
                  NEW ALBUM ‘DIG!’ OUT NOW
                </h1>
              </Box>
            </AlbumNameColumn>
            <Column gridColumn="span 12 / span 12">
              <Box display="flex" justifyContent="center">
                <CtaLink href="https://mamasgun.lnk.to/get-dig" target="_blank">
                  <CtaText
                    as="span"
                    color="var(--dark-brown)"
                    fontSize="1.25rem"
                  >
                    Buy
                  </CtaText>
                </CtaLink>
                <Text
                  as="span"
                  color="var(--marigold)"
                  style={{
                    display: 'inline-block',
                    margin: '0 10px',
                    userSelect: 'none'
                  }}
                >
                  ▲
                </Text>
                <CtaLink href="https://mamasgun.lnk.to/DIG" target="_blank">
                  <CtaText
                    as="span"
                    color="var(--dark-brown)"
                    fontSize="1.25rem"
                  >
                    Stream
                  </CtaText>
                </CtaLink>
              </Box>
            </Column>
          </Grid>
        </Box>
        <Box display="flex" justifyContent="center" py={4}>
          <Stack
            direction="row"
            gap="32px"
            style={{ flexWrap: 'wrap', rowGap: '8px' }}
          >
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://www.facebook.com/MamasGun/"
                triangleColor="var(--yellow)"
              >
                <Facebook />
              </SocialIcon>
            </Box>
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://www.instagram.com/mamasgun_uk"
                triangleColor="var(--yellow-orange)"
              >
                <Instagram />
              </SocialIcon>
            </Box>
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://www.youtube.com/channel/UC6TJpdNV3SLZWtvSwiaCcyA"
                triangleColor="var(--orange)"
              >
                <YouTube />
              </SocialIcon>
            </Box>
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://www.tiktok.com/@mamasgunuk"
                triangleColor="var(--red-brown)"
              >
                <Tiktok />
              </SocialIcon>
            </Box>
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://open.spotify.com/artist/09bP40OuEV5tOM1rQnZNxI"
                triangleColor="var(--dark-red)"
              >
                <Spotify />
              </SocialIcon>
            </Box>
            <Box height={[24, 32]} width={[24, 32]} alignItems="center">
              <SocialIcon
                href="https://music.apple.com/artist/mamas-gun/215662409"
                triangleColor="var(--dark-brown)"
              >
                <AppleMusic />
              </SocialIcon>
            </Box>
          </Stack>
        </Box>
      </Container>
      <NewsletterSignupInternalLink />
    </Section>
  );
}

const AlbumNameColumn = styled(Column)`
  display: flex;
  flex-wrap: wrap;
  align-self: center;
`;

const CtaWrapper = styled(Box)<{
  transform: null | string | Array<string | null>;
  transformOrigin: null | string | Array<string | null>;
}>`
  ${system({
    transform: true,
    transformOrigin: true
  })}
`;

const CtaText = styled(Text)`
  text-transform: uppercase;
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-thickness: 5px;
  font-family: var(--display-font-stack);
  letter-spacing: var(--display-spacing-sm);
`;

const CtaLink = styled.a`
  &:focus-visible {
    outline: 5px solid blue;
  }
`;
